export const environment = {
  production: false,
  api_url: 'https://test.monitoringobjects.mossport.ru'
};
